import { useQuery } from 'react-query';

import { FactFilters } from '../../types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { createFilterBody } from '@/helpers/createFilterParams';

interface GetSubsetFactAllIdsProps {
  matterId: string;
  subsetId: string;
  searchQuery?: string;
  filters: FactFilters;
  enabled?: boolean;
}

interface GetSubsetFactAllIdsResponse {
  factIds: string[];
}

function useGetSubsetFactAllIds({
  matterId,
  subsetId,
  searchQuery,
  filters,
  enabled = false,
}: GetSubsetFactAllIdsProps) {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      searchQuery: searchQuery || '',
      ...createFilterBody(filters),
      paginated: false,
    },
  });

  return useQuery<GetSubsetFactAllIdsResponse, Error>(
    [QueryEntity.SubsetFactAllIds, { matterId, subsetId }, { searchQuery, filters }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/fact/fact-ids`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetSubsetFactAllIds;
